import { Component, forwardRef, HostListener, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormElementBase } from '../../adapter/form-element-base.adapter';

@Component({
  selector: 'tekman-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
})
export class SelectComponent extends FormElementBase implements ControlValueAccessor, OnInit {
  @Input() label = '';
  @Input() svg = '';
  @Input() placeholder = '';
  @Input() inline = false;
  @Input() set disabled(isDisabled: boolean) {
    this.isDisabled = isDisabled;
  }
  @Input() selectedOpt = '';
  @Input() style: { [key: string]: string };
  open = false;
  @Input() isHelpMenu: boolean;
  @Input() config: ISelectConfig;
  defaultConfig: ISelectConfig = {
    svg: {
      iconOpen: 'arrow-up',
      iconClose: 'arrow-down',
      isShow: true,
      style: {
        color: '#4F4F4F',
        customClass: '',
        cBackgroundHover: 'bg-fondoGrisClaro',
        cBackground: 'transparent',
      },
    },
  };

  @HostListener('document:click', ['$event']) onDocumentClick(event: any) {
    event.stopPropagation();
    this.open = false;
  }

  constructor() {
    super();
  }

  ngOnInit() {
    this.config = { ...this.defaultConfig, ...this.config };
  }

  openCloseSelector(event) {
    event.stopPropagation();
    this.open = !this.open;
  }

  closeDropdown() {
    this.open = false;
  }
}

export interface ISelectConfig {
  svg?: {
    iconOpen?: string;
    iconClose?: string;
    isShow?: boolean;
    style?: {
      color?: string;
      cBackgroundHover?: string;
      cBackground?: string;
      customClass?: string;
    };
  };
}
